export const calcDiffPercentage = (cur: number, prev: number): { cur: number; diff: number } => {
  if (cur === 0 || prev === 0) return { cur, diff: 0 };
  return { cur, diff: cur / prev - 1 };
};
